// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { PermitToWorkGeometryModel } from "../../../../../api/APIClient";

export enum ViewerMode {
    AssetInfo = 1,
    PermitsToWork,
    PowerBI,
    PowerBIonModel,
    AssetControl,
    Security,
    Maintenance,
    Energy,
    Commercial,
    Floors,
    Confort,
    Loomers,
    Aforo,
    // Calendar,
}

export interface IPermitToWorkGeometryToCollisions {
    permitId: string;
    // shape: string;
    center: THREE.Vector3;
    radius: number;
    height: number;
    boundingBox: ISizeVector3;
}

export interface IShowLabelsPermitsToWork {
    tag: string;
    id: string;
}

export interface ISizeVector3 {
    sizeX: number;
    sizeY: number;
    sizeZ: number;
}

export interface IRuleSetCollisionResult {
    mesh1: { asset: string; meshId: string };
    mesh2: { asset: string; meshId: string };
}

export interface IPermitToWorkCollision {
    id: string;
    dbIds: number[];
    geometry: PermitToWorkGeometryModel | undefined;
}

export interface ILabelInfo {
    id: string;
    title: string;
    data: { [key: string]: string };
}

export interface ILabelInfoData {
    title: string;
    text: string;
}

export interface IWOCollisionInfo {
    id: string;
    startDate: Date;
    dueDate: Date;
}

export interface IElementsCollision {
    workOrderId1: string;
    workOrderId2: string;
}

export interface ICollisions {
    collisions: Array<IElementsCollision>;
    workTypes: Array<string>;
}

export const colorNameToRGB = (name: string): { r: number; g: number; b: number } => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substr(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return {
        r: rgbArray[0],
        g: rgbArray[1],
        b: rgbArray[2],
    };
};

export const colorHexToVector4 = (colorHex: string): THREE.Vector4 => {
    const color = new THREE.Color(colorHex);
    return new window.THREE.Vector4(color.r, color.g, color.b, 1);
};

export const colorHexToRgb = (colorHex: string): THREE.Color => {
    const color = new THREE.Color(colorHex);
    return color;
};

export const convertHexToRGB = (colorHex: string | undefined): string => {
    if (colorHex?.length !== 7 || undefined) {
        return "rgb(255, 255, 255)";
    }
    const color1 = colorHex.slice(1);
    const aRgbHex = color1.match(/.{1,2}/g);
    const aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
    const rgb = `rgb(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]})`;
    return rgb;
};

export const covertHexToRgbArray = (hex) => {
    const redColor = parseInt(hex[1] + hex[2], 16);
    const greenColor = parseInt(hex[3] + hex[4], 16);
    const blueColor = parseInt(hex[5] + hex[6], 16);
    const rgb = [redColor, greenColor, blueColor];
    return rgb;
};

export const colorNameToVector4 = (name: string): THREE.Vector4 => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substr(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return new window.THREE.Vector4(rgbArray[0] / 255, rgbArray[1] / 255, rgbArray[2] / 255, 1);
};

export const intersectSphereBox = (sphere: THREE.Sphere, box: THREE.Box3): boolean => {
    const closest = new window.THREE.Vector3(sphere.center.x, sphere.center.y, sphere.center.z);
    // Get box closest point to sphere center by clamping
    closest.clamp(box.min, box.max);

    const distance = sphere.center.distanceToSquared(closest);
    return distance < sphere.radius * sphere.radius;
};

export const getDateXDaysAgo = (numOfDays: number, date = new Date()) => {
    const daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() - numOfDays);
    return daysAgo;
};

export const getDateXHoursAgo = (numOfHours: number, date = new Date()) => {
    const numberOfMlSeconds = date.getTime();
    const hoursInMlSeconds = numOfHours * 60 * 60 * 1000;
    const newDate = new Date(numberOfMlSeconds - hoursInMlSeconds);
    return newDate;
};
